export default __webpack_public_path__ + "static/media/information--motorway-exit-ahead--g2.b8daa7b6.png";